import { FiCheck } from 'react-icons/fi'
import Card from './ui/Card'
import Reveal from './ui/Reveal'

const comparisonFeatures = [
  {
    feature: 'Dispositivos',
    gratuito: '1',
    basico: 'Até 2',
    pro: 'Até 5',
  },
  {
    feature: 'Usuários Convidados (Compartilhamento)',
    gratuito: 'X',
    basico: '1',
    pro: 'Até 5',
  },
  {
    feature: 'Retenção de Histórico',
    gratuito: '30 dias',
    basico: '90 dias',
    pro: 'Até 1 ano',
  },
  {
    feature: 'Alertas de Nível',
    gratuito: true,
    basico: true,
    pro: true,
  },
  {
    feature: 'Relatório Semanal (E-mail)',
    gratuito: false,
    basico: true,
    pro: true,
  },
  {
    feature: 'Alerta de Vazamento/Pico',
    gratuito: '30 dias Trial',
    basico: true,
    pro: true,
    isTrial: true,
  },
  {
    feature: 'Alerta de Status Bomba/Relé',
    gratuito: false,
    basico: false,
    pro: true,
  },
  {
    feature: 'Controle Remoto (Relé/Bomba)',
    gratuito: false,
    basico: false,
    pro: true,
  },
  {
    feature: 'Análise de Horário de Pico',
    gratuito: false,
    basico: false,
    pro: true,
  },
  {
    feature: 'Exportação de Dados',
    gratuito: false,
    basico: false,
    pro: true,
  },
]

const PLANS = [
  { id: 'gratuito', name: 'Gratuito', key: 'gratuito', highlight: false },
  { id: 'basico', name: 'Básico', key: 'basico', highlight: false },
  { id: 'pro', name: 'Pro', key: 'pro', highlight: true },
]

const ComparisonTable = () => {
  const renderCell = (value, isPro = false) => {
    if (value === true) {
      return (
        <div className="flex justify-center">
          <FiCheck className="w-5 h-5 sm:w-6 sm:h-6 text-accent font-bold" strokeWidth={3} />
        </div>
      )
    }
    if (value === false) {
      return (
        <div className="flex justify-center">
          <span className="text-gray-400 dark:text-gray-500 text-base">—</span>
        </div>
      )
    }
    if (typeof value === 'string' && value.includes('Trial')) {
      return (
        <div className="flex justify-center">
          <span className="bg-accent/20 dark:bg-accent/30 text-accent px-3 py-1 rounded-full text-xs sm:text-sm font-semibold">
            {value}
          </span>
        </div>
      )
    }
    return (
      <div className={`text-center font-semibold text-sm ${isPro ? 'text-accent' : 'text-gray-700 dark:text-gray-200'}`}>
        {value}
      </div>
    )
  }

  const renderMobileValue = (value) => {
    if (value === true) return <FiCheck className="w-5 h-5 text-accent flex-shrink-0" strokeWidth={3} />
    if (value === false) return <span className="text-gray-400 dark:text-gray-500 text-sm">—</span>
    if (typeof value === 'string' && value.includes('Trial')) {
      return <span className="bg-accent/20 dark:bg-accent/30 text-accent px-2 py-0.5 rounded-full text-xs font-semibold">{value}</span>
    }
    return <span className="text-gray-700 dark:text-gray-200 text-sm font-medium">{value}</span>
  }

  return (
    <Reveal direction="up">
      <div className="mt-8 sm:mt-10">
        <div className="text-center mb-6 sm:mb-8">
          <p className="text-xs sm:text-sm font-bold text-accent uppercase tracking-[0.2em] mb-2">Tabela</p>
          <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 dark:text-white">
            Comparativo de Recursos
          </h3>
          <div className="mt-3 w-16 h-1 rounded-full bg-accent/80 mx-auto" />
        </div>

        {/* Mobile: cards por plano */}
        <div className="md:hidden space-y-4">
          {PLANS.map((plan) => (
            <Card
              key={plan.id}
              padding="md"
              hover={false}
              className={plan.highlight ? 'border-2 border-accent/50 bg-accent/5 dark:bg-accent/10' : ''}
            >
              <h4 className={`text-base font-extrabold mb-4 pb-2 border-b border-gray-200 dark:border-gray-700 ${plan.highlight ? 'text-accent' : 'text-gray-900 dark:text-white'}`}>
                {plan.name}
              </h4>
              <ul className="space-y-2.5">
                {comparisonFeatures.map((item, idx) => (
                  <li key={idx} className="flex items-center justify-between gap-3 text-sm">
                    <span className="text-gray-600 dark:text-gray-300 flex-1 min-w-0">{item.feature}</span>
                    <span className="flex-shrink-0">{renderMobileValue(item[plan.key])}</span>
                  </li>
                ))}
              </ul>
            </Card>
          ))}
        </div>

        {/* Desktop: tabela */}
        <Card padding="none" hover={false} className="overflow-hidden w-full min-w-0 hidden md:block">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[600px]">
              <thead>
                <tr className="border-b-2 border-gray-200 dark:border-gray-700 bg-gray-100/80 dark:bg-gray-800">
                  <th className="sticky left-0 z-10 min-w-[160px] bg-gray-100/80 p-4 text-left dark:bg-gray-800">
                    <span className="text-sm font-semibold text-gray-500 dark:text-gray-400">
                      Recurso
                    </span>
                  </th>
                  <th className="p-4 text-center">
                    <span className="text-sm font-bold text-gray-900 dark:text-white">
                      Gratuito
                    </span>
                  </th>
                  <th className="p-4 text-center">
                    <span className="text-sm font-bold text-gray-900 dark:text-white">
                      Básico
                    </span>
                  </th>
                  <th className="bg-accent/10 p-4 text-center dark:bg-accent/15">
                    <span className="text-sm font-bold text-accent">
                      Pro
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {comparisonFeatures.map((item, index) => (
                  <tr
                    key={index}
                    className={`border-b border-gray-100 dark:border-gray-800 ${
                      index % 2 === 0 ? 'bg-white dark:bg-gray-800' : 'bg-gray-50/50 dark:bg-gray-800/50'
                    }`}
                  >
                    <td className={`sticky left-0 z-10 min-w-[160px] p-3 sm:p-4 text-xs font-medium text-gray-900 dark:text-white sm:text-sm ${
                      index % 2 === 0 ? 'bg-white dark:bg-gray-800' : 'bg-gray-50/50 dark:bg-gray-800/50'
                    }`}>
                      {item.feature}
                    </td>
                    <td className="p-3 sm:p-4 text-sm">{renderCell(item.gratuito)}</td>
                    <td className="p-3 sm:p-4 text-sm">{renderCell(item.basico)}</td>
                    <td className="bg-accent/5 p-3 sm:p-4 text-sm dark:bg-accent/10">{renderCell(item.pro, true)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </Reveal>
  )
}

export default ComparisonTable
